function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Tuy_Web_Icon");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M61,65.76H55a.72.72,0,0,0-.74.74V71a.71.71,0,0,0,.74.74H61a.71.71,0,0,0,.74-.74V66.51a.71.71,0,0,0-.74-.74Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M65.44,53.88H55a.71.71,0,0,0-.74.74v4.46a.71.71,0,0,0,.74.74h10.4a.72.72,0,0,0,.74-.74V54.62a.72.72,0,0,0-.74-.74Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M74.89,30.32a.72.72,0,0,0-.53-.21H55a.71.71,0,0,0-.74.74v4.46A.71.71,0,0,0,55,36H74.36a.71.71,0,0,0,.74-.74V30.85A.72.72,0,0,0,74.89,30.32Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M69.9,42H55a.72.72,0,0,0-.74.74v4.46a.72.72,0,0,0,.74.74H69.9a.71.71,0,0,0,.74-.74V42.74A.71.71,0,0,0,69.9,42Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M47.84,58.57H44.37V31a.87.87,0,0,0-.87-.87h-7a.87.87,0,0,0-.87.87V58.57H32.18A.87.87,0,0,0,31.51,60l7.83,11.68a.87.87,0,0,0,1.35,0L48.52,60a.87.87,0,0,0-.67-1.41Z"
});

var SvgSort = function SvgSort(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 100 100",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSort, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sort.1283012c.svg";
export { ForwardRef as ReactComponent };